import { createFileUploadSlot } from './hrmApi';
import { inlineImageUrl } from '../../../shared/inlineImages';

const unwrap = payload => payload?.data?.data ?? payload?.data ?? payload ?? {};
const base64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(String(reader.result).split(',')[1]);
  reader.onerror = () => reject(new Error('The pasted image could not be read.'));
  reader.readAsDataURL(file);
});

export async function uploadHrmInlineImage(viewUserId, parentType, parentId, file, options) {
  const { transfer, signal, onProgress } = options;
  if (signal.aborted) throw new Error('Image paste cancelled.');
  if (!file.size || file.size > 1048576) throw new Error('For HRM image paste, choose an image up to 1 MiB. Larger files can use the attachment control.');
  const scope = { parentType: parentId ? parentType : 'InlineDraft', ...(parentId ? { parentId, recordId: parentId } : {}) };
  if (!transfer.uploaded) {
    const base64Data = await base64(file);
    if (signal.aborted) throw new Error('Image paste cancelled.');
    onProgress(10);
    transfer.uploaded = unwrap(await createFileUploadSlot(viewUserId, {
      ...scope, fileName: file.name, name: file.name, contentType: file.type,
      size: file.size, base64Data, inlineImage: true,
    }));
  }
  const uploaded = transfer.uploaded;
  const contentDocumentId = uploaded.contentDocumentId || uploaded.fileId;
  if (!/^069[A-Za-z0-9]{12}(?:[A-Za-z0-9]{3})?$/.test(contentDocumentId || '')) throw new Error('Salesforce did not confirm the image upload.');
  onProgress(90);
  let contentDownloadUrl = inlineImageUrl(uploaded.contentDownloadUrl || uploaded.downloadUrl);
  if (!contentDownloadUrl) {
    const linked = unwrap(await createFileUploadSlot(viewUserId, {
      ...scope, fileName: file.name, fileId: contentDocumentId, inlineImage: true,
    }));
    contentDownloadUrl = inlineImageUrl(linked.contentDownloadUrl || linked.downloadUrl);
  }
  if (!contentDownloadUrl) throw new Error('Salesforce did not return a direct image link. Retry to finish linking this upload.');
  return { ...uploaded, contentDocumentId, id: contentDocumentId, fileId: contentDocumentId,
    name: file.name, contentType: file.type, contentDownloadUrl, downloadUrl: contentDownloadUrl };
}
